export default __webpack_public_path__ + "static/estatehero-f1cd196ee6d493f9e467b7d0ef9ac263.png";